const centerTextPlugin = {
  beforeDraw(chart) {
    if (chart.config.options.elements.center) {
      const {ctx} = chart;
      const centerConfig = chart.config.options.elements.center;
      const txt = centerConfig.text;
      const color = centerConfig.color || '#000';
      const maxFontSize = centerConfig.maxFontSize || 20;
      const sidePadding = centerConfig.sidePadding || 20;
      const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

      const stringWidth = ctx.measureText(txt).width;
      const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
      const widthRatio = elementWidth / stringWidth;
      const newFontSize = Math.floor(30 * widthRatio);
      const fontSizeToUse = Math.min(newFontSize, maxFontSize);

      ctx.font = `600 ${fontSizeToUse}px "Hiragino Kaku Gothic Pro", sans-serif`;
      ctx.fillStyle = color;
      ctx.fillText(txt, centerX, centerY);
    }
  }
};

if (typeof Chart !== 'undefined') {
  Chart.pluginService.register(centerTextPlugin);
}

function createDoughnutChart(canvasId, chartData, centerText) {
  const chartCanvas = document.getElementById(canvasId);
  if (!chartCanvas) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const ctx = chartCanvas.getContext('2d');

        new Chart(ctx, {
          type: 'doughnut',
          data: chartData,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 1500,
              easing: 'easeOutCubic'
            },
            cutoutPercentage: 70,
            legend: {
              display: false
            },
            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const label = data.labels[tooltipItem.index];
                  const value = data.datasets[0].data[tooltipItem.index];
                  return `${label  }：${  value  }%`;
                }
              }
            },
            elements: {
              center: {
                text: centerText,
                color: '#333333',
                maxFontSize: 20,
                sidePadding: 20
              }
            }
          }
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3
  });

  observer.observe(chartCanvas);
}

function initializeUserAttributeCharts() {
  // 性別比率チャート
  createDoughnutChart('genderChart', {
    labels: ['男性', '女性'],
    datasets: [{
      data: [47, 53],
      backgroundColor: ['#61c31d', '#93db62'],
      borderWidth: 0
    }]
  }, '性別比率');

  // 年齢比率チャート
  createDoughnutChart('ageChart', {
    labels: ['18-24歳', '25-34歳', '35-44歳', '45-54歳', '55-64歳', '65歳-'],
    datasets: [{
      data: [24, 28, 22, 16, 6, 4],
      backgroundColor: ['#44a702', '#61c31d', '#93db62', '#c8ebb0', '#e8efca', '#f4f5f3'],
      borderWidth: 0
    }]
  }, '年齢比率');

  // 地域比率チャート
  createDoughnutChart('regionChart', {
    labels: ['北海道', '東北', '関東', '中部', '関西', '中国', '四国', '九州'],
    datasets: [{
      data: [4, 4, 57, 9, 15, 4, 2, 5],
      backgroundColor: ['#44a702', '#61c31d', '#93db62', '#c8ebb0', '#c8ebb0', '#f4f5f3', '#d3e0c1', '#b8c7a0'],
      borderWidth: 0
    }]
  }, '地域比率');

  // デバイス比チャート
  createDoughnutChart('deviceChart', {
    labels: ['スマートフォン', 'パソコン', 'タブレット'],
    datasets: [{
      data: [69, 29, 2],
      backgroundColor: ['#61c31d', '#93db62', '#c8ebb0'],
      borderWidth: 0
    }]
  }, 'デバイス比');
}

export default initializeUserAttributeCharts;
